import TagLine from "./Tagline";

const Heading = ({ className, title, text, tag }) => {
  return (
    <div
      className={`${className} flex justify-center mx-auto mb-12 lg:mb-20 md:text-center`}
    >
      {tag && <TagLine className="mb-4 md:justify-center">{tag}</TagLine>}
      {title && <h2 className="h2 uppercase">{title}</h2>}
      {text && <p className="body-2 mt-4 text-n-2">{text}</p>}
    </div>
  );
};

export default Heading;